import { Link, Outlet } from "react-router-dom";
import { Brand } from "@/components/layout/Brand";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/layout/ThemeToggle";
import { Container } from "@/components/layout/Container";
import { PageTransition } from "@/components/motion/PageTransition";

export function PublicShell() {
  return (
    <div className="min-h-screen min-h-[100dvh] flex flex-col bg-bg text-text w-full">
      <header className="sticky top-0 z-30 border-b border-border bg-bg/80 backdrop-blur">
        <Container size="lg" className="flex h-16 items-center justify-between">
          <Brand />
          <nav className="flex items-center gap-1 sm:gap-3">
            <ThemeToggle />
            <Button variant="ghost" size="sm" asChild>
              <Link to="/auth/login">Log in</Link>
            </Button>
            <Button variant="primary" size="sm" asChild>
              <Link to="/auth/otp">Try free</Link>
            </Button>
          </nav>
        </Container>
      </header>

      <main className="flex-1">
        <PageTransition>
          <Outlet />
        </PageTransition>
      </main>

      <footer className="border-t border-border">
        <Container size="lg" className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 py-8 text-sm text-text-muted">
          <p>&copy; {new Date().getFullYear()} StaxED. CBSE classes 8-12.</p>
          <nav className="flex flex-wrap gap-x-5 gap-y-2">
            <Link to="/" className="hover:text-text">Home</Link>
            <Link to="/contact" className="hover:text-text">Contact</Link>
            <Link to="/privacy" className="hover:text-text">Privacy</Link>
            <Link to="/terms" className="hover:text-text">Terms</Link>
            <Link to="/refund-policy" className="hover:text-text">Refunds</Link>
            <Link to="/shipping-policy" className="hover:text-text">Delivery</Link>
          </nav>
        </Container>
      </footer>
    </div>
  );
}
